var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { getBpmnId } from '../getBpmnId';
export var getExclusiveGateway = function (PolygonNodeModel) {
    var ExclusiveGatewayModel = /** @class */ (function (_super) {
        __extends(ExclusiveGatewayModel, _super);
        function ExclusiveGatewayModel(data, graphModel) {
            var _this = this;
            if (!data.id) {
                data.id = "Gateway_" + getBpmnId();
            }
            _this = _super.call(this, data, graphModel) || this;
            _this.points = [
                [25, 0],
                [50, 25],
                [25, 50],
                [0, 25],
            ];
            return _this;
        }
        ExclusiveGatewayModel.extendKey = 'ExclusiveGatewayModel';
        return ExclusiveGatewayModel;
    }(PolygonNodeModel));
    return ExclusiveGatewayModel;
};
export var getExclusiveGatewayView = function (PolygonNode, h) {
    var ExclusiveGatewayNode = /** @class */ (function (_super) {
        __extends(ExclusiveGatewayNode, _super);
        function ExclusiveGatewayNode() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ExclusiveGatewayNode.prototype.getShape = function () {
            var attributes = _super.prototype.getAttributes.call(this);
            var x = attributes.x, y = attributes.y, fill = attributes.fill, stroke = attributes.stroke, strokeWidth = attributes.strokeWidth, width = attributes.width, height = attributes.height, points = attributes.points;
            return h('g', {
                transform: "matrix(1 0 0 1 " + (x - width / 2) + " " + (y - height / 2) + ")",
            }, h('polygon', {
                fill: fill,
                x: x,
                y: y,
                stroke: stroke,
                strokeWidth: strokeWidth,
                points: points,
            }), h('path', {
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                d: 'm 16,15 7.42857142857143,9.714285714285715 -7.42857142857143,9.714285714285715 3.428571428571429,0 5.714285714285715,-7.464228571428572 5.714285714285715,7.464228571428572 3.428571428571429,0 -7.42857142857143,-9.714285714285715 7.42857142857143,-9.714285714285715 -3.428571428571429,0 -5.714285714285715,7.464228571428572 -5.714285714285715,-7.464228571428572 -3.428571428571429,0 z',
            }));
        };
        ExclusiveGatewayNode.extendKey = 'ExclusiveGatewayNode';
        return ExclusiveGatewayNode;
    }(PolygonNode));
    return ExclusiveGatewayNode;
};
